"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
// tslint:disable: max-line-length
var infoIconPaths = (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("g", null,
        react_1.default.createElement("circle", { fill: "#e5f4fb", cx: "32", cy: "32", r: "32" }),
        react_1.default.createElement("path", { fill: "#0090e3", transform: "translate(25.5 45) scale(0.02 -0.02) ", d: "M57 0V164L202 194V887L45 917V1082H474V194L619 164V0H57ZM192 1319V1560H474V1319H192Z" }))));
// tslint:enable: max-line-length
exports.default = infoIconPaths;
//# sourceMappingURL=Info.js.map